import Actions from '../../actions/actions';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import withDataLoaded from '../with_data_loaded';
import { userLoader } from '../../actions/data_loaders';
import PageSpinner from '../shared/page_spinner';
import { UserAdminDataGrid, UserAdminNoRows, UserAdminToolbar } from './components/user_admin_data_grid';
import AddIcon from '@mui/icons-material/Add';
import SearchHelper from '../../helpers/search_helper';
import FeaturePermissionsHelper from '../../helpers/feature_permissions_helper';

function PricingGroupList() {
  const pricingGroupList = useSelector((redux) => redux.pricingGroupsList);
  const currUser = useSelector((redux) => redux.user);
  const view = useSelector((redux) => redux.view);

  const [pogsToDisplay, setPogsToDisplay] = useState(pricingGroupList);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    if (pricingGroupList?.length) {
      setPogsToDisplay(SearchHelper.search(searchText, pricingGroupList, ['label']));
    }
  }, [pricingGroupList, searchText]);

  const customToolbar = useMemo(() => {
    return UserAdminToolbar(
      'Product Option Groups',
      true,
      <button
        id="qa-admin-list-add-pricing-group-button"
        className="action-primary action-alt add-item-button"
        onClick={() => {
          Actions.clearPricingGroup();
          Actions.setRoute(`/account/companies/${view.coid}/pricing-groups/new`);
        }}
        disabled={!FeaturePermissionsHelper.hasPermission(currUser, 'POG', 'CREATE')}
      >
        <AddIcon className="add-item-icon" />
        Add Group
      </button>
    );
  }, [view?.coid, currUser]);

  if (currUser === null) {
    return <PageSpinner />;
  }

  return (
    <div className="user-admin-page datagrid-page" id="qa-pricing-list-page">
      <UserAdminDataGrid
        columns={[
          { field: 'id', hide: true },
          { field: 'label', headerName: 'Name', flex: 1, sortable: false },
        ]}
        rows={pogsToDisplay}
        hideFooter
        onCellClick={({ row }) => {
          Actions.clearPricingGroup();
          Actions.setRoute(`/account/companies/${view.coid}/pricing-groups/${row.id}`);
        }}
        components={{
          LoadingOverlay: PageSpinner,
          Toolbar: customToolbar,
          NoRowsOverlay: UserAdminNoRows,
        }}
        componentsProps={{
          toolbar: {
            value: searchText,
            clearSearch: () => setSearchText(''),
            onChange: (event) => setSearchText(event.target.value),
          },
        }}
        rowClassFunc={(row) => `qa-pog-list-row-${row.label.replace(/\s/g, '')}`}
      />
    </div>
  );
}

const connectedPricingGroupList = withDataLoaded({
  WithData: PricingGroupList,
  WithoutData: PageSpinner,
  data: [
    userLoader,
    {
      storeKeys: ['pricingGroupsList'],
      loadDataFn: ({ view }) => Actions.getPricingGroupList(view.coid),
      emptyIsStillData: true,
    },
  ],
});

export default connectedPricingGroupList;
